import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Heading,
  Textarea,
  VStack,
  HStack,
  useToast,
  Text,
  FormControl,
  FormLabel,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

const SetupMissedCallMessage = () => {
  const [missedCallMessage, setMissedCallMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const toast = useToast();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchSetup();
  }, []);

  const fetchSetup = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/api/setup");
      setMissedCallMessage(data.missedCallMessage || "");
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to load setup configuration",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      await axios.put("/api/setup", { missedCallMessage });
      toast({
        title: "Success",
        description: "Missed call message saved successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to save missed call message",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box p={6}>
      <VStack spacing={6} align="stretch">
        <Heading size="lg">Missed Call Message Setup</Heading>

        <Alert status="info">
          <AlertIcon />
          This message will be sent to customers when we miss their calls.
        </Alert>

        <FormControl>
          <FormLabel fontSize="md" fontWeight="semibold">
            Missed Call Message Text
          </FormLabel>
          <Textarea
            value={missedCallMessage}
            onChange={(e) => setMissedCallMessage(e.target.value)}
            placeholder="Enter the message to send when calls are missed..."
            size="lg"
            minH="120px"
            resize="vertical"
          />
          <Text fontSize="sm" color="gray.500" mt={2}>
            Characters: {missedCallMessage.length}
          </Text>
        </FormControl>

        <HStack spacing={4}>
          <Button
            colorScheme="blue"
            onClick={handleSave}
            isLoading={saving}
            loadingText="Saving..."
          >
            Save Changes
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
};

export default SetupMissedCallMessage;